import $ from 'jquery';

$.Deferred.delay = function (ms) {
    var d = $.Deferred();
    setTimeout(d.resolve, ms);
    return d.promise();
};
